import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { baseUrl } from "../Common/data.js";
import { Link } from "react-router-dom";

function Services() {
  // const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   fetch(`${baseUrl}/api/services`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setData(data?.data);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching services:", err);
  //       setLoading(false);
  //     });
  // }, []);

  return (
    <>
      <Navbar />
      <div className="AboutUs-banner">
        <h3>Services</h3>
        <p>Discover Our Story: Learn More About Who We Are</p>
      </div>
      <div className="services-div">
        {/* {loading ? (
          <p>Loading services...</p>
        ) : data.length === 0 ? (
          <p>No active services found.</p>
        ) : (
          data.map((service) => (
            <div
              key={service._id}
              className="services-div-box"
              style={{
                backgroundImage: `url(${service.imageUrl || "/fallback.png"})`
              }}
            >
              {service.imageUrl && (
                <img
                  src={service.imageUrl}
                  alt={service.name}
                  style={{ width: "100%", height: "auto" }}
                />
              )}
              <h3>{service.name}</h3>
              <p style={{ color: "#9B9BA6" }}>{service.description?.slice(0, 100)}...</p>
              <button>Read More</button>
            </div>
          ))
        )} */}


        <div className="services-div-box services-div-box2">
          <Link to='/siliconengineering'>
        <div className="overlay">

          <h3>Silicon/semiconductor Engineering</h3>
          <Link to='/siliconengineering'>

          <button>Read More</button>
          </Link>
        </div>
</Link>
        </div>

        <div className="services-div-box services-div-box3">
            <Link to='/systemdesign'>
        <div className="overlay">

          <h3>System Design</h3>
            <Link to='/systemdesign'>

          <button>Read More</button>
          </Link>
        </div>
</Link>
        </div>

        <div className="services-div-box services-div-box4">
            <Link to='/embeddedsolutions'>
        <div className="overlay">

          <h3>Embedded Solutions</h3>
            <Link to='/embeddedsolutions'>

          <button>Read More</button>
          </Link>
        </div>
</Link>
        </div>

        <div className="services-div-box services-div-box5">
           <Link to='/artificialintelligence'>
        <div className="overlay">

          <h3>Artificial Intelligence</h3>
           <Link to='/artificialintelligence'>

          <button>Read More</button>
          </Link>
        </div>
</Link>
        </div>

        <div className="services-div-box services-div-box6">
          <Link to='/automotivesolutions'>
        <div className="overlay">

          <h3>Automotive Solutions</h3>
          <Link to='/automotivesolutions'>

          <button>Read More</button>
          </Link>
        </div>
</Link>
        </div>

      </div>
      <Footer />
    </>
  );
}

export default Services;
